import ApiService from "../service/ApiService";

let moduleApi = {};
let moduleName = "allowed_ip";

moduleApi.list = async (dataFilter, loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: loading == undefined ? false : loading,
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id, loading) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id },
    dontLoading: loading == undefined ? false : loading,
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

export default moduleApi;
